"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var material_1 = require("@mui/material");
var styles_1 = require("@mui/material/styles");
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var PREFIX = 'ChatIcon';
var classes = {
    main: "".concat(PREFIX, "-main"),
};
var StyledSvgIcon = (0, styles_1.styled)(material_1.SvgIcon)((_a = {},
    _a["&.".concat(classes.main)] = {
        stroke: 'black',
    },
    _a));
var ChatIcon = function (props) {
    return ((0, jsx_runtime_1.jsxs)(StyledSvgIcon, __assign({ fontSize: "small" }, props, { fill: "none", viewBox: "0 0 36 36", style: __assign({ color: 'transparent' }, props.style), className: (0, classnames_1.default)(classes.main, props.className) }, { children: [(0, jsx_runtime_1.jsx)("path", { d: "M6.38842 24.8904C4.71114 22.0629 4.12374 18.7203 4.73652 15.4904C5.34931 12.2604 7.12013 9.36527 9.71646 7.34857C12.3128 5.33186 15.556 4.33233 18.8372 4.53765C22.1183 4.74298 25.2116 6.13904 27.5363 8.46369C29.861 10.7883 31.257 13.8817 31.4624 17.1628C31.6677 20.4439 30.6682 23.6872 28.6515 26.2835C26.6348 28.8799 23.7397 30.6507 20.5097 31.2635C17.2798 31.8763 13.9372 31.2889 11.1097 29.6116L11.1098 29.6115L6.44712 30.9437C6.25421 30.9988 6.05007 31.0013 5.85586 30.951C5.66164 30.9007 5.48442 30.7993 5.34256 30.6575C5.20069 30.5156 5.09934 30.3384 5.04902 30.1442C4.99869 29.9499 5.00122 29.7458 5.05634 29.5529L6.38852 24.8903L6.38842 24.8904Z", stroke: "current", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), (0, jsx_runtime_1.jsx)("path", { d: "M13.5 15.75H22.5", stroke: "current", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), (0, jsx_runtime_1.jsx)("path", { d: "M13.5 20.25H22.5", stroke: "current", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })] })));
};
exports.default = ChatIcon;
